export function AppleIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true">
      <path d="M17.369 14.288C17.1012 14.9106 16.7709 15.5043 16.383 16.06C15.865 16.7987 15.4417 17.31 15.113 17.594C14.6063 18.0593 14.0627 18.299 13.482 18.313C13.064 18.313 12.5613 18.193 11.974 17.953C11.3867 17.713 10.8457 17.5933 10.351 17.594C9.833 17.594 9.277 17.7137 8.683 17.953C8.08767 18.193 7.607 18.3193 7.241 18.332C6.683 18.356 6.12667 18.11 5.572 17.594C5.218 17.2853 4.77533 16.7557 4.244 16.005C3.674 15.205 3.206 14.275 2.84 13.215C2.44667 12.0723 2.25 10.9643 2.25 9.891C2.25 8.66233 2.51567 7.60367 3.047 6.715C3.44974 6.01794 4.02478 5.43601 4.717 5.025C5.39991 4.61726 6.17868 4.39781 6.974 4.389C7.41667 4.38967 7.99867 4.525 8.72 4.795C9.44067 5.06633 9.90233 5.20233 10.105 5.203C10.2577 5.203 10.7697 5.043 11.641 4.723C12.4637 4.427 13.1593 4.30367 13.728 4.353C15.272 4.47633 16.4293 5.08533 17.2 6.18C15.82 7.01667 15.1373 8.18633 15.152 9.689C15.1653 10.8597 15.5887 11.8317 16.422 12.605C16.8 12.963 17.2233 13.2407 17.692 13.438C17.5907 13.7327 17.483 14.016 17.369 14.288ZM13.83 0.367C13.83 1.28433 13.496 2.13933 12.828 2.932C12.022 3.874 11.048 4.419 9.991 4.332C9.97696 4.21686 9.96962 4.10099 9.969 3.985C9.969 3.105 10.352 2.163 11.033 1.393C11.373 1.003 11.805 0.678667 12.329 0.42C12.8517 0.164667 13.3457 0.0246667 13.811 0C13.8243 0.122667 13.831 0.245 13.831 0.367" />
    </svg>
  );
}

export function PlayStoreIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true">
      <g clipPath="url(#clip0_playstore)">
        <g filter="url(#filter0_dd_playstore)">
          <path
            d="M1.82094 0.307C1.59494 0.547 1.46094 0.917 1.46094 1.399V18.596C1.46094 19.078 1.59494 19.449 1.82094 19.689L1.87894 19.745L11.5129 10.111V9.884L1.87894 0.25L1.82094 0.307Z"
            fill="url(#paint0_linear_playstore)"
          />
          <path
            d="M14.7217 13.3268L11.5117 10.1138V9.88678L14.7227 6.67578L14.7957 6.71678L18.6007 8.87878C19.6867 9.49578 19.6867 10.5058 18.6007 11.1238L14.7957 13.2858L14.7217 13.3268Z"
            fill="url(#paint1_linear_playstore)"
          />
          <g filter="url(#filter1_d_playstore)">
            <path
              d="M14.7953 13.284L11.5103 10L1.82031 19.69C2.17731 20.07 2.76931 20.117 3.43531 19.739L14.7953 13.284Z"
              fill="url(#paint2_linear_playstore)"
            />
          </g>
          <path
            d="M14.7963 6.71454L3.43631 0.260537C2.77031 -0.117463 2.17831 -0.0694629 1.82031 0.309537L11.5123 9.99954L14.7963 6.71454Z"
            fill="url(#paint3_linear_playstore)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_dd_playstore"
          x="1.46094"
          y="-0.117"
          width="17.9531"
          height="20.234"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.117" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_playstore" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.117" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_playstore" result="effect2_dropShadow_playstore" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_playstore" result="shape" />
        </filter>
        <filter
          id="filter1_d_playstore"
          x="1.82031"
          y="9.883"
          width="12.9766"
          height="10.117"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.117" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_playstore" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_playstore" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_playstore"
          x1="10.6579"
          y1="1.217"
          x2="-2.39106"
          y2="14.267"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#00A0FF" />
          <stop offset="0.007" stopColor="#00A1FF" />
          <stop offset="0.26" stopColor="#00BEFF" />
          <stop offset="0.512" stopColor="#00D2FF" />
          <stop offset="0.76" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_playstore"
          x1="20.0147"
          y1="10.0008"
          x2="1.19872"
          y2="10.0008"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFE000" />
          <stop offset="0.409" stopColor="#FFBD00" />
          <stop offset="0.775" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_playstore"
          x1="13.0113"
          y1="11.784"
          x2="-4.68569"
          y2="29.481"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_playstore"
          x1="-0.619687"
          y1="-5.41546"
          x2="7.28231"
          y2="2.48654"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#32A071" />
          <stop offset="0.069" stopColor="#2DA771" />
          <stop offset="0.476" stopColor="#15CF74" />
          <stop offset="0.801" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
        <clipPath id="clip0_playstore">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ChromeIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true">
      <g clipPath="url(#clip0_chrome)">
        <path
          d="M9.4983 0.00172279C9.4983 0.00172279 15.0985 -0.253449 18.0673 5.44724H9.02194C9.02194 5.44724 7.31533 5.39207 5.85708 7.48862C5.43841 8.36862 4.98851 9.27552 5.49337 11.0624C4.76526 9.81414 1.62891 4.2831 1.62891 4.2831C1.62891 4.2831 3.84105 0.22724 9.4983 0.00172279Z"
          fill="#EF3F36"
        />
        <path
          d="M17.7768 14.4715C17.7768 14.4715 15.1928 19.5115 8.83594 19.2618C9.62172 17.8859 13.36 11.3294 13.36 11.3294C13.36 11.3294 14.2632 9.86042 13.1971 7.53283C12.6556 6.72456 12.1033 5.87835 10.3234 5.42801C11.7552 5.41421 18.0516 5.42801 18.0516 5.42801C18.0516 5.42801 20.4103 9.39697 17.7761 14.4715"
          fill="#FCD900"
        />
        <path
          d="M1.26092 14.5132C1.26092 14.5132 -1.75805 9.72838 1.63481 4.27734C2.41788 5.65321 6.15613 12.2098 6.15613 12.2098C6.15613 12.2098 6.96228 13.7367 9.48317 13.9642C10.444 13.8932 11.4442 13.8318 12.722 12.4987C12.0176 13.7608 8.85753 19.2753 8.85753 19.2753C8.85753 19.2753 4.28124 19.3601 1.26024 14.5132"
          fill="#61BC5B"
        />
        <path
          d="M8.83594 19.3092L10.1089 13.9326C10.1089 13.9326 11.5068 13.8216 12.6794 12.5195C11.9513 13.8161 8.83594 19.3092 8.83594 19.3092Z"
          fill="#5AB055"
        />
        <path
          d="M5.23828 9.7182C5.23828 7.34785 7.13625 5.42578 9.47664 5.42578C11.817 5.42578 13.715 7.34785 13.715 9.7182C13.715 12.0885 11.817 14.0106 9.47664 14.0106C7.13557 14.0079 5.23828 12.0885 5.23828 9.7182Z"
          fill="white"
        />
        <path
          d="M5.94922 9.71901C5.94922 7.74591 7.52758 6.14453 9.47779 6.14453C11.4253 6.14453 13.0064 7.74315 13.0064 9.71832C13.0064 11.6907 11.4287 13.2921 9.47779 13.2921C7.53029 13.2921 5.94922 11.6907 5.94922 9.71832"
          fill="url(#paint0_linear_chrome)"
        />
        <path
          d="M18.0518 5.43337L12.8132 6.98923C12.8132 6.98923 12.0234 5.81474 10.3242 5.43337C11.7981 5.42509 18.0518 5.43337 18.0518 5.43337Z"
          fill="#EACA05"
        />
        <path
          d="M5.39091 10.8686C4.65533 9.57757 1.62891 4.28516 1.62891 4.28516L5.50898 8.17205C5.50898 8.17205 5.11066 9.00171 5.25994 10.1893L5.39091 10.8686Z"
          fill="#DF3A32"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_chrome"
          x1="9.47779"
          y1="6.19488"
          x2="9.47779"
          y2="13.0769"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#86BBE5" />
          <stop offset="1" stopColor="#1072BA" />
        </linearGradient>
        <clipPath id="clip0_chrome">
          <rect width="19" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SafariIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true">
      <g clipPath="url(#clip0_safari)">
        <path
          d="M10.0003 19.5739C15.3693 19.5739 19.7223 15.2209 19.7223 9.85091C19.7223 4.48191 15.3693 0.128906 10.0003 0.128906C4.63034 0.128906 0.277344 4.48191 0.277344 9.85091C0.277344 15.2209 4.63034 19.5739 10.0003 19.5739Z"
          fill="url(#paint0_linear_safari)"
        />
        <path
          d="M10.0013 18.8464C11.1824 18.8464 12.3518 18.6138 13.443 18.1618C14.5341 17.7098 15.5256 17.0474 16.3607 16.2122C17.1958 15.3771 17.8583 14.3857 18.3102 13.2945C18.7622 12.2034 18.9948 11.0339 18.9948 9.85287C18.9948 8.67183 18.7622 7.50235 18.3102 6.41121C17.8583 5.32007 17.1958 4.32863 16.3607 3.49351C15.5256 2.65839 14.5341 1.99593 13.443 1.54396C12.3518 1.092 11.1824 0.859375 10.0013 0.859375C7.61609 0.859375 5.32856 1.8069 3.64195 3.49351C1.95534 5.18012 1.00781 7.46765 1.00781 9.85287C1.00781 12.2381 1.95534 14.5256 3.64195 16.2122C5.32856 17.8988 7.61609 18.8464 10.0013 18.8464Z"
          fill="url(#paint1_radial_safari)"
        />
        <path
          d="M10.0555 18.8376C11.2365 18.8376 12.4059 18.605 13.497 18.153C14.5881 17.7011 15.5794 17.0387 16.4145 16.2036C17.2496 15.3685 17.912 14.3771 18.3639 13.286C18.8159 12.195 19.0485 11.0255 19.0485 9.84456C19.0485 8.66358 18.8159 7.49417 18.3639 6.40309C17.912 5.31201 17.2496 4.32063 16.4145 3.48555C15.5794 2.65047 14.5881 1.98805 13.497 1.53611C12.4059 1.08417 11.2365 0.851562 10.0555 0.851563C7.67041 0.851563 5.383 1.79904 3.69649 3.48555C2.00997 5.17207 1.0625 7.45947 1.0625 9.84456C1.0625 12.2297 2.00997 14.5171 3.69649 16.2036C5.383 17.8901 7.67041 18.8376 10.0555 18.8376Z"
          fill="url(#paint2_linear_safari)"
          fillOpacity="0.2"
        />
        <path
          d="M16.2804 4.14062L9.02638 8.79063H9.01938V8.79763L9.01137 8.80463L4.48438 16.2716L11.1384 10.9166L11.1464 10.9086V10.9016L16.2804 4.14062Z"
          fill="black"
          fillOpacity="0.05"
        />
        <path d="M16.1466 3.70703L8.97656 8.80303L11.1026 10.915L16.1466 3.70703Z" fill="#CD151E" />
        <path d="M8.98047 8.78903L10.0515 9.84403L16.1435 3.70703L8.98047 8.78903Z" fill="#FA5153" />
        <path d="M8.9805 8.78906L11.1075 10.8991L3.9375 15.9961L8.9805 8.78906Z" fill="#ACACAC" />
        <path d="M3.9375 15.9971L10.0525 9.84506L8.9815 8.78906L3.9375 15.9971Z" fill="#EEEEEE" />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_safari"
          x1="10.0003"
          y1="19.5739"
          x2="10.0003"
          y2="0.128906"
          gradientUnits="userSpaceOnUse">
          <stop offset="0.25" stopColor="#DBDBDA" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_safari"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.2643 7.87738) scale(10.9773 10.9773)">
          <stop stopColor="#2ABCE1" />
          <stop offset="0.114" stopColor="#2ABBE1" />
          <stop offset="1" stopColor="#3375F8" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_safari"
          x1="9.8845"
          y1="7.27256"
          x2="5.6865"
          y2="14.8036"
          gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0" />
          <stop offset="1" />
        </linearGradient>
        <clipPath id="clip0_safari">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function FirefoxIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true">
      <path
        d="M18.1181 6.70366C17.7381 5.78491 16.9663 4.79365 16.3606 4.48053C16.8538 5.44928 17.1388 6.42116 17.2481 7.14553C17.2481 7.14553 17.2488 7.15053 17.25 7.16053C16.2594 4.68553 14.5794 3.68741 13.2075 1.51428C13.1375 1.40491 13.0681 1.29553 13.0006 1.17803C12.966 1.11834 12.9339 1.05725 12.9044 0.994905C12.8448 0.880331 12.799 0.759059 12.7681 0.633655C12.7644 0.629397 12.7593 0.626532 12.7538 0.62553C12.7484 0.624823 12.7429 0.624823 12.7375 0.62553L12.7331 0.62803C12.731 0.628864 12.729 0.629905 12.7269 0.631155L12.7306 0.62678C10.5294 1.91866 9.78313 4.30803 9.71438 5.50428C8.83453 5.56439 7.99338 5.88899 7.30125 6.43553C7.22895 6.37398 7.1532 6.31659 7.07438 6.26365C6.87399 5.56336 6.86557 4.82207 7.05 4.11741C6.15 4.52866 5.45 5.17741 4.94125 5.75116H4.93688C4.58938 5.30991 4.61375 3.85553 4.63375 3.55178C4.62938 3.53303 4.375 3.6849 4.34188 3.70803C4.03479 3.9272 3.74938 4.1722 3.48563 4.44303C3.18564 4.74687 2.91214 5.07577 2.66813 5.42615C2.10495 6.22701 1.70544 7.13117 1.4925 8.08678L1.48063 8.1449C1.46438 8.22178 1.405 8.60865 1.39438 8.69303V8.71178C1.31688 9.1122 1.26875 9.51636 1.25 9.92428V9.96865C1.24938 14.818 5.17188 18.7493 10.0106 18.7493C14.3444 18.7493 17.9419 15.5962 18.6469 11.4543C18.661 11.3418 18.6744 11.2289 18.6869 11.1155C18.8613 9.60928 18.6675 8.02678 18.1181 6.70303M8.02063 13.5768C8.06125 13.5955 8.1 13.6174 8.14188 13.6368L8.14813 13.6405L8.02063 13.5768ZM17.2513 7.16428V7.15616V7.16553V7.16428Z"
        fill="url(#paint0_linear_firefox)"
      />
      <path
        d="M18.1175 6.70359C17.7375 5.78484 16.9663 4.79359 16.3606 4.48047C16.8531 5.44922 17.1381 6.42109 17.2475 7.14547V7.16422C18.0744 9.40984 17.6237 11.6942 16.975 13.0898C15.9706 15.2492 13.54 17.463 9.735 17.3548C5.6275 17.238 2.00625 14.1798 1.33 10.1767C1.20688 9.54547 1.33 9.22484 1.39187 8.71234C1.31688 9.10672 1.2875 9.22109 1.25 9.92359V9.96859C1.25 14.818 5.1725 18.7492 10.0113 18.7492C14.345 18.7492 17.9425 15.5961 18.6475 11.4542C18.6617 11.3417 18.675 11.2288 18.6875 11.1155C18.8606 9.60922 18.6669 8.02672 18.1181 6.70297"
        fill="url(#paint1_radial_firefox)"
      />
      <path
        d="M13.8617 7.73703L13.9161 7.77766C13.6964 7.38642 13.4225 7.02828 13.1023 6.71391C10.3792 3.98453 12.3886 0.795156 12.7273 0.633281L12.7311 0.628906C10.5298 1.92078 9.78359 4.31016 9.71484 5.50641C9.81672 5.49953 9.91859 5.49078 10.0223 5.49078C11.6648 5.49078 13.0955 6.39578 13.8617 7.73703Z"
        fill="url(#paint2_radial_firefox)"
      />
      <path
        d="M10.0275 8.28203C10.0131 8.50078 9.24313 9.25391 8.97375 9.25391C6.4825 9.25391 6.07812 10.7639 6.07812 10.7639C6.1875 12.0364 7.07188 13.0839 8.14188 13.6383C8.19104 13.6629 8.23958 13.6864 8.2875 13.7089C8.37333 13.7456 8.45917 13.7808 8.545 13.8145C8.91186 13.9443 9.29617 14.018 9.685 14.0333C14.0519 14.2389 14.8981 8.80078 11.7469 7.22141C12.5531 7.08078 13.3906 7.40641 13.8594 7.73578C13.0931 6.39453 11.6619 5.48828 10.0194 5.48828C9.91562 5.48828 9.81375 5.49703 9.71188 5.50391C8.83254 5.56474 7.99209 5.88977 7.30063 6.43641C7.43438 6.55016 7.58563 6.70141 7.90313 7.01453C8.49875 7.60391 10.0231 8.21016 10.0269 8.28141"
        fill="url(#paint3_radial_firefox)"
      />
      <path
        d="M6.89266 6.14281L7.07516 6.26344C6.87456 5.5632 6.86593 4.82191 7.05016 4.11719C6.15016 4.52844 5.45016 5.17719 4.94141 5.75094C4.98266 5.74969 6.25391 5.72656 6.89266 6.14344"
        fill="url(#paint4_radial_firefox)"
      />
      <path
        d="M1.33167 10.1788C2.00792 14.1825 5.62917 17.24 9.73979 17.3575C13.5448 17.4657 15.9735 15.2519 16.9792 13.0925C17.6279 11.6969 18.0792 9.41254 17.2517 7.16629V7.14941L17.2535 7.16441C17.5642 9.19816 16.5323 11.1688 14.9185 12.5013L14.9142 12.5125C11.7698 15.0782 8.76104 14.0607 8.15167 13.645L8.02417 13.5813C6.19104 12.7044 5.43354 11.0294 5.59604 9.59379C4.04854 9.59379 3.52042 8.28504 3.52042 8.28504C3.52042 8.28504 4.91042 7.29191 6.74167 8.15566C8.43792 8.95566 10.031 8.28566 10.031 8.28504C10.0279 8.21379 8.50354 7.60566 7.90854 7.01879C7.59104 6.70504 7.43979 6.55379 7.30667 6.44066C7.23437 6.37911 7.15862 6.32172 7.07979 6.26879C7.02729 6.23191 6.97042 6.19566 6.89729 6.14816C6.25854 5.73191 4.98729 5.75441 4.94542 5.75629H4.94167C4.59417 5.31504 4.61854 3.86066 4.63792 3.55629C4.63417 3.53754 4.37917 3.68941 4.34667 3.71254C4.04042 3.93129 3.75292 4.17754 3.49042 4.44754C3.19 4.75254 2.91708 5.08024 2.67167 5.43066C2.10872 6.23156 1.70942 7.13572 1.49667 8.09129C1.48917 8.10816 1.17792 9.47191 1.33167 10.1788Z"
        fill="url(#paint5_radial_firefox)"
      />
      <path
        d="M13.1016 6.71178C13.4216 7.02616 13.6953 7.38428 13.9153 7.77553C13.9612 7.81011 14.0049 7.84678 14.0466 7.88553C16.0328 9.71803 14.9941 12.3124 14.9153 12.4987C16.5285 11.1662 17.5603 9.19616 17.2497 7.16178C16.2591 4.68553 14.5797 3.68678 13.2072 1.51428C13.1385 1.40491 13.0685 1.29553 13.001 1.17803C12.9664 1.11834 12.9343 1.05725 12.9047 0.994905C12.8451 0.880331 12.7994 0.759059 12.7685 0.633655C12.7647 0.629397 12.7597 0.626532 12.7541 0.62553C12.7487 0.624823 12.7432 0.624823 12.7378 0.62553L12.7335 0.62803C12.7314 0.628864 12.7293 0.629905 12.7272 0.631155C12.3878 0.793655 10.3785 3.98241 13.1022 6.71178"
        fill="url(#paint6_radial_firefox)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_firefox"
          x1="16.9587"
          y1="3.4324"
          x2="2.38313"
          y2="17.4643"
          gradientUnits="userSpaceOnUse">
          <stop offset="0.05" stopColor="#FFF44F" />
          <stop offset="0.11" stopColor="#FFE847" />
          <stop offset="0.22" stopColor="#FFC830" />
          <stop offset="0.37" stopColor="#FF980E" />
          <stop offset="0.4" stopColor="#FF8B16" />
          <stop offset="0.46" stopColor="#FF672A" />
          <stop offset="0.53" stopColor="#FF3647" />
          <stop offset="0.7" stopColor="#E31587" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_firefox"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.2863 2.63609) scale(18.2654 18.3055)">
          <stop offset="0.13" stopColor="#FFBD4F" />
          <stop offset="0.19" stopColor="#FFAC31" />
          <stop offset="0.25" stopColor="#FF9D17" />
          <stop offset="0.28" stopColor="#FF980E" />
          <stop offset="0.4" stopColor="#FF563B" />
          <stop offset="0.47" stopColor="#FF3750" />
          <stop offset="0.71" stopColor="#F5156C" />
          <stop offset="0.78" stopColor="#EB0878" />
          <stop offset="0.86" stopColor="#E50080" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_firefox"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.8155 -1.51609) scale(13.2325 13.2615)">
          <stop offset="0.13" stopColor="#FFF44F" />
          <stop offset="0.25" stopColor="#FFDC3E" />
          <stop offset="0.51" stopColor="#FF9D12" />
          <stop offset="0.53" stopColor="#FF980E" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_firefox"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.5925 14.9027) scale(8.69688 8.71594)">
          <stop offset="0.35" stopColor="#3A8EE6" />
          <stop offset="0.47" stopColor="#5C79F0" />
          <stop offset="0.67" stopColor="#9059FF" />
          <stop offset="1" stopColor="#C139E6" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_firefox"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.38016 1.88656) scale(6.25675 6.2705)">
          <stop stopColor="#FFE226" />
          <stop offset="0.12" stopColor="#FFDB27" />
          <stop offset="0.3" stopColor="#FFC82A" />
          <stop offset="0.5" stopColor="#FFA930" />
          <stop offset="0.73" stopColor="#FF7E37" />
          <stop offset="0.79" stopColor="#FF7139" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_firefox"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.3004 -2.08809) scale(26.6943 26.7529)">
          <stop offset="0.11" stopColor="#FFF44F" />
          <stop offset="0.46" stopColor="#FF980E" />
          <stop offset="0.62" stopColor="#FF5634" />
          <stop offset="0.72" stopColor="#FF3647" />
          <stop offset="0.9" stopColor="#E31587" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_firefox"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.7192 0.833033) rotate(84.245) scale(19.4998 12.7839)">
          <stop stopColor="#FFF44F" />
          <stop offset="0.06" stopColor="#FFE847" />
          <stop offset="0.17" stopColor="#FFC830" />
          <stop offset="0.3" stopColor="#FF980E" />
          <stop offset="0.36" stopColor="#FF8B16" />
          <stop offset="0.45" stopColor="#FF672A" />
          <stop offset="0.57" stopColor="#FF3647" />
          <stop offset="0.74" stopColor="#E31587" />
        </radialGradient>
      </defs>
    </svg>
  );
}

export function EdgeIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true">
      <g clipPath="url(#clip0_edge)">
        <path
          d="M18.0497 14.8866C17.783 15.0261 17.5086 15.1489 17.2266 15.2547C16.3297 15.5907 15.3793 15.7615 14.4216 15.7591C10.7253 15.7591 7.50531 13.2166 7.50531 9.95344C7.50976 9.51581 7.63105 9.08732 7.85664 8.71229C8.08222 8.33726 8.40392 8.02931 8.78844 7.82031C5.44469 7.96094 4.58594 11.4447 4.58594 13.4859C4.58594 19.2572 9.90469 19.8422 11.0509 19.8422C11.6697 19.8422 12.6009 19.6628 13.1603 19.4859L13.2622 19.4522C15.4148 18.7082 17.2499 17.2533 18.4653 15.3272C18.5025 15.2685 18.5192 15.1991 18.5126 15.13C18.5059 15.0608 18.4765 14.9958 18.4288 14.9453C18.3811 14.8948 18.318 14.8615 18.2493 14.8509C18.1807 14.8403 18.1104 14.8528 18.0497 14.8866Z"
          fill="url(#paint0_linear_edge)"
        />
        <path
          opacity="0.35"
          d="M18.0497 14.8866C17.783 15.0261 17.5086 15.1489 17.2266 15.2547C16.3297 15.5907 15.3793 15.7615 14.4216 15.7591C10.7253 15.7591 7.50531 13.2166 7.50531 9.95344C7.50976 9.51581 7.63105 9.08732 7.85664 8.71229C8.08222 8.33726 8.40392 8.02931 8.78844 7.82031C5.44469 7.96094 4.58594 11.4447 4.58594 13.4859C4.58594 19.2572 9.90469 19.8422 11.0509 19.8422C11.6697 19.8422 12.6009 19.6628 13.1603 19.4859L13.2622 19.4522C15.4148 18.7082 17.2499 17.2533 18.4653 15.3272C18.5025 15.2685 18.5192 15.1991 18.5126 15.13C18.5059 15.0608 18.4765 14.9958 18.4288 14.9453C18.3811 14.8948 18.318 14.8615 18.2493 14.8509C18.1807 14.8403 18.1104 14.8528 18.0497 14.8866Z"
          fill="url(#paint1_radial_edge)"
        />
        <path
          d="M8.25943 18.8611C7.56269 18.4285 6.9589 17.8617 6.48318 17.1936C4.42943 14.3811 5.04568 10.4361 7.85881 8.38297C8.15297 8.16839 8.46339 7.98047 8.79006 7.81922C9.03381 7.70422 9.45006 7.49672 10.0038 7.50672C10.7944 7.51297 11.5376 7.88797 12.0107 8.52234C12.3263 8.94422 12.5001 9.45359 12.5076 9.98047C12.5076 9.96359 14.4182 3.76172 6.25756 3.76172C2.8288 3.76172 0.00817977 7.01609 0.00817977 9.87172C-0.00464545 11.3822 0.318572 12.8766 0.95443 14.2467C3.10693 18.8398 8.3588 21.093 13.1707 19.4892C12.3566 19.746 11.4966 19.8231 10.6499 19.7152C9.80314 19.6073 8.98991 19.317 8.2663 18.8642L8.25943 18.8611Z"
          fill="url(#paint2_linear_edge)"
        />
        <path
          opacity="0.41"
          d="M8.25943 18.8611C7.56269 18.4285 6.9589 17.8617 6.48318 17.1936C4.42943 14.3811 5.04568 10.4361 7.85881 8.38297C8.15297 8.16839 8.46339 7.98047 8.79006 7.81922C9.03381 7.70422 9.45006 7.49672 10.0038 7.50672C10.7944 7.51297 11.5376 7.88797 12.0107 8.52234C12.3263 8.94422 12.5001 9.45359 12.5076 9.98047C12.5076 9.96359 14.4182 3.76172 6.25756 3.76172C2.8288 3.76172 0.00817977 7.01609 0.00817977 9.87172C-0.00464545 11.3822 0.318572 12.8766 0.95443 14.2467C3.10693 18.8398 8.3588 21.093 13.1707 19.4892C12.3566 19.746 11.4966 19.8231 10.6499 19.7152C9.80314 19.6073 8.98991 19.317 8.2663 18.8642L8.25943 18.8611Z"
          fill="url(#paint3_radial_edge)"
        />
        <path
          d="M11.9 11.6288C11.8363 11.7113 11.6419 11.8244 11.6419 12.0713C11.6419 12.275 11.775 12.4713 12.0106 12.6356C13.1344 13.4169 15.2525 13.3138 15.2575 13.3138C16.09 13.3116 16.9067 13.0863 17.6225 12.6613C18.3445 12.2398 18.9437 11.6368 19.3606 10.9122C19.7775 10.1876 19.9978 9.36661 19.9994 8.53063C20.02 6.78 19.3744 5.61563 19.1138 5.10063C17.4581 1.86188 13.885 0 10 0C4.53062 0 0.076875 4.39125 0 9.85875C0.0375 7.00438 2.875 4.69875 6.25 4.69875C6.52313 4.69875 8.0825 4.72562 9.53125 5.48562C10.8075 6.15625 11.4763 6.965 11.9413 7.76688C12.4238 8.60063 12.51 9.65438 12.51 10.0731C12.51 10.4925 12.2956 11.1144 11.9 11.6288Z"
          fill="url(#paint4_radial_edge)"
        />
        <path
          d="M11.9 11.6288C11.8363 11.7113 11.6419 11.8244 11.6419 12.0713C11.6419 12.275 11.775 12.4713 12.0106 12.6356C13.1344 13.4169 15.2525 13.3138 15.2575 13.3138C16.09 13.3116 16.9067 13.0863 17.6225 12.6613C18.3445 12.2398 18.9437 11.6368 19.3606 10.9122C19.7775 10.1876 19.9978 9.36661 19.9994 8.53063C20.02 6.78 19.3744 5.61563 19.1138 5.10063C17.4581 1.86188 13.885 0 10 0C4.53062 0 0.076875 4.39125 0 9.85875C0.0375 7.00438 2.875 4.69875 6.25 4.69875C6.52313 4.69875 8.0825 4.72562 9.53125 5.48562C10.8075 6.15625 11.4763 6.965 11.9413 7.76688C12.4238 8.60063 12.51 9.65438 12.51 10.0731C12.51 10.4925 12.2956 11.1144 11.9 11.6288Z"
          fill="url(#paint5_radial_edge)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_edge"
          x1="4.58594"
          y1="13.8309"
          x2="18.5141"
          y2="13.8309"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#0C59A4" />
          <stop offset="1" stopColor="#114A8B" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_edge"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.2809 13.9422) scale(7.45094 7.07838)">
          <stop offset="0.72" stopOpacity="0" />
          <stop offset="0.95" stopOpacity="0.53" />
          <stop offset="1" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_edge"
          x1="11.9369"
          y1="7.79297"
          x2="3.23443"
          y2="17.2717"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#1B9DE2" />
          <stop offset="0.16" stopColor="#1595DF" />
          <stop offset="0.67" stopColor="#0680D7" />
          <stop offset="1" stopColor="#0078D4" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_edge"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.53568 15.5523) rotate(-81.38) scale(11.19 9.06393)">
          <stop offset="0.76" stopOpacity="0" />
          <stop offset="0.95" stopOpacity="0.5" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_edge"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(2.01625 3.70937) rotate(92.29) scale(15.8138 33.6833)">
          <stop stopColor="#35C1F1" />
          <stop offset="0.11" stopColor="#34C1ED" />
          <stop offset="0.23" stopColor="#2FC2DF" />
          <stop offset="0.31" stopColor="#2BC3D2" />
          <stop offset="0.67" stopColor="#36C752" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_edge"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(18.7251 6.08575) rotate(73.74) scale(7.60419 6.1594)">
          <stop stopColor="#66EB6E" />
          <stop offset="1" stopColor="#66EB6E" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_edge">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function WindowsIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true">
      <g clipPath="url(#clip0_windows)">
        <path
          d="M0 0H9.48103V9.47692H0V0ZM10.519 0H20V9.47692H10.519V0ZM0 10.519H9.48103V20H0V10.519ZM10.519 10.519H20V20H10.519"
          fill="#0078D4"
        />
      </g>
      <defs>
        <clipPath id="clip0_windows">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function LinuxIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true">
      <g clipPath="url(#clip0_linux)">
        <path
          d="M9.93145 2C9.54256 2 9.15238 2.07375 8.79979 2.2575C8.42516 2.45187 8.11793 2.76313 7.92932 3.13063C7.74006 3.49813 7.66618 3.89062 7.65451 4.32312C7.63312 5.14437 7.67395 6.00563 7.73812 6.78625C7.75497 7.02375 7.78608 7.1625 7.75432 7.40688C7.64932 7.92563 7.17877 8.27438 6.92729 8.73C6.65053 9.2325 6.53386 9.80063 6.32516 10.3331C6.13395 10.82 5.86562 11.2769 5.68479 11.7675C5.43136 12.4531 5.35553 13.2069 5.52275 13.9169C5.65043 14.4581 5.91682 14.9656 6.2759 15.4C6.22405 15.49 6.17349 15.5819 6.12034 15.6713C5.95377 15.9481 5.75025 16.2112 5.65562 16.5181C5.60831 16.6712 5.58951 16.835 5.61997 16.9925C5.65043 17.15 5.7334 17.3006 5.86303 17.4006C5.94793 17.4656 6.05099 17.5081 6.15664 17.5319C6.26229 17.555 6.37182 17.5606 6.48071 17.5588C6.89358 17.55 7.29414 17.4294 7.6934 17.3281C7.93062 17.2681 8.16914 17.215 8.40831 17.1669C9.25997 16.9987 10.2102 17.0663 11.0003 17.1763C11.2679 17.2156 11.5337 17.2662 11.7968 17.3281C12.209 17.4244 12.6193 17.5469 13.0432 17.5588C13.1547 17.5619 13.2675 17.5569 13.3764 17.5337C13.4853 17.51 13.5909 17.4675 13.6778 17.4006C13.808 17.3006 13.891 17.1494 13.9215 16.9919C13.9519 16.8344 13.9331 16.67 13.8852 16.5162C13.7892 16.2087 13.5838 15.9469 13.414 15.6713C13.3465 15.5619 13.2843 15.4506 13.2176 15.3413C13.7296 14.7869 14.1418 14.1456 14.3803 13.4412C14.6402 12.6725 14.6882 11.8444 14.5787 11.0425C14.4691 10.2406 14.2053 9.46312 13.8586 8.72687C13.423 7.80437 13.0568 7.47062 12.7911 6.66C12.5046 5.78375 12.7412 4.74687 12.5279 3.9525C12.4521 3.6825 12.3309 3.42438 12.1747 3.18813C11.9919 2.91125 11.7599 2.66375 11.4844 2.47125C11.045 2.16375 10.4927 2 9.93145 2Z"
          fill="#020204"
        />
        <path
          d="M8.38568 6.62584C8.32735 6.69646 8.28976 6.78146 8.26642 6.86896C8.24374 6.95646 8.23531 7.04709 8.23142 7.13771C8.22429 7.31834 8.23596 7.50209 8.18605 7.67646C8.1329 7.86271 8.01429 8.02459 7.89827 8.18146C7.6967 8.45396 7.49318 8.73396 7.39402 9.05459C7.33374 9.24834 7.31364 9.45396 7.33503 9.65584C7.11013 9.97459 6.91503 10.314 6.753 10.6671C6.508 11.2027 6.34013 11.7727 6.28114 12.3552C6.20855 13.0683 6.30318 13.8021 6.5955 14.4608C6.80614 14.9377 7.12114 15.3733 7.52753 15.7133C7.73364 15.8858 7.96309 16.0327 8.20809 16.149C9.05781 16.5521 10.1078 16.5527 10.9433 16.1233C11.3801 15.899 11.7489 15.5708 12.1041 15.239C12.318 15.039 12.5312 14.834 12.6946 14.594C13.0089 14.1308 13.1185 13.5683 13.1865 13.019C13.3051 12.059 13.309 11.044 12.8722 10.1733C12.7218 9.87334 12.5215 9.59709 12.2811 9.35771C12.2175 8.93896 12.0911 8.52834 11.9077 8.14396C11.7748 7.86584 11.6135 7.60146 11.4903 7.32021C11.4398 7.20459 11.3957 7.08584 11.3399 6.97271C11.2836 6.85959 11.2148 6.75084 11.1202 6.66396C11.0243 6.57521 10.9044 6.51209 10.778 6.47209C10.6516 6.43146 10.5181 6.41334 10.3852 6.40709C10.1188 6.39396 9.85244 6.42771 9.58605 6.41709C9.37411 6.40896 9.16281 6.37334 8.95087 6.38521C8.84522 6.39146 8.73957 6.40959 8.64105 6.44834C8.54253 6.48646 8.45179 6.54584 8.38568 6.62584Z"
          fill="#FDFDFB"
        />
        <ellipse cx="9.09" cy="8.04" rx="0.45" ry="0.6" fill="#020204" />
        <ellipse cx="10.59" cy="8.04" rx="0.45" ry="0.6" fill="#020204" />
        <path
          d="M9.5 10.5C9.5 10.5 9.7 11 10 11C10.3 11 10.5 10.5 10.5 10.5"
          stroke="#020204"
          strokeWidth="0.3"
          strokeLinecap="round"
        />
        <path
          d="M8.5 9.5C8.5 9.5 9 9.8 9.5 9.5"
          stroke="#020204"
          strokeWidth="0.2"
          strokeLinecap="round"
        />
        <path
          d="M10.5 9.5C10.5 9.5 11 9.8 11.5 9.5"
          stroke="#020204"
          strokeWidth="0.2"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_linux">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
